import uris from '../utils/uris'
import axios from '../utils/axiosWrapper'
import orderBy from 'lodash/orderBy'
import find from 'lodash/find'

let adminUsersData = []

export default {
  getAdminUsers (options) {
    // TODO: Enable cache please
    axios.get(uris.URL_GET_ADMIN_USERS)
      .then((response) => {
        if (options.onSuccess) {
          console.log(response.data.rows)
          adminUsersData = orderBy(response.data.rows, ['name'], ['asc'])
          if (options.userID) {
            // eslint-disable-next-line
            options.onSuccess(find(adminUsersData, u => u.userID == options.userID) || {})
          } else {
            options.onSuccess(adminUsersData)
          }
        }
      }, (err) => {
        console.warn(err)
        if (options.onError) {
          options.onError(err)
        }
      })
  },
  getSubscriptions (options) {
    axios.post(uris.URL_GET_ADMIN_SUBSCRIPTIONS, {
      userID: options.userID
    })
      .then((response) => {
        options.onSuccess(
          orderBy(response.data.rows, ['itemName', 'isFolder'], ['asc', 'desc'])
        )
      }, (err) => {
        console.warn(err)
        if (options.onError) {
          options.onError(err)
        }
      })
  },
  getFoldersSubscriptions (options) {
    axios.get(uris.URL_GET_ADMIN_FOLDERS_SUBSCRIPTIONS)
      .then((response) => {
        if (options.onSuccess) {
          options.onSuccess(response.data.rows)
        }
      }, (err) => {
        console.warn('!!!', err)
      })
  },
  updateUserInfo (options) {
    axios.post(uris.URL_ADMIN_UPDATE_USER_INFO, options.data)
      .then((response) => {
        console.log('USER UPDATED', response)
        if (options.onSuccess) {
          options.onSuccess(response)
        }
      }, (err) => {
        console.warn('ERROR UPDATING USER', err)
        if (options.onError) {
          options.onError(err)
        }
      })
  },
  updatePassword (options) {
    axios.post(uris.URL_ADMIN_UPDATE_USER_PASSWORD, {
      userID: options.userID,
      newPassword: options.newPassword
    })
      .then((response) => {
        console.log('USER PASSWORD UPDATED', response)
        if (options.onSuccess) {
          options.onSuccess(response)
        }
      }, (err) => {
        console.warn('ERROR UPDATING USER PASSWORD', err)
        if (options.onError) {
          options.onError(err)
        }
      })
  },
  updateAccessLevel (options) {
    axios.post(uris.URL_ADMIN_UPDATE_ACCESS_LEVEL, {
      userID: options.userID,
      newUserType: options.newUserType,
      isEnabled: options.isEnabled
    })
      .then((response) => {
        console.log('response', response)
        if (options.onSuccess) {
          options.onSuccess(response)
        }
      }, (err) => {
        console.warn('ERR', err)
        if (options.onError) {
          options.onError(err)
        }
      })
  },
  createUser (options) {
    axios.post(uris.URL_ADMIN_CREATE_USER, {
      name: options.userData.name,
      company: options.userData.company,
      description: options.userData.description,
      mail: options.userData.mail,
      phone: options.userData.phone,
      profileImageUrl: options.userData.profileImageUrl,
      password: options.userData.password,
      userType: options.userData.userType,
      permissions: options.userData.permissions
    })
      .then((response) => {
        console.log('response', response)
        if (options.onSuccess) {
          options.onSuccess(response)
        }
      }, (err) => {
        console.warn('ERR', err)
        if (options.onError) {
          options.onError(err)
        }
      })
  }
}



// WEBPACK FOOTER //
// ./src/storage/adminStorage.js